<template>
    <li class="list-group-item drop-down-hover" :class="task.status ? 'complete text-gray-500' : 'incomplete'">

        <template v-if="editing">
	        <div class="d-flex flex-fill align-items-center">
	            <div class="input-group mr-2 flex-grow-1">
	                <input class="form-control" v-model="task_data.title" placeholder="Title">
	                <div class="input-group-append">
	                    <div class="input-group-text" @click="toggleOptions()"><i class="fal fa-cog"></i></div>
	                </div>  
	            </div>
	            <date-picker 
                    readonly="true"
                    class="w-25 date-picker"
                    v-model="task_data.due_date"
                    :config="config.datePickerOptions"
                    input-class="form-control bg-white" />                       
	        </div>
	        <div v-if="options" class="d-flex flex-fill mt-2"> 
	            <div class="w-50 mr-2">
	                <label class="text-gray-500 mb-0">Change type</label>                   
	                <v-select
                        v-model="task_data.type"
	                    :options="task_types"
                        :reduce="task_type => task_type.value"
                        :clearable="false" />  
	            </div>

	            <div class="w-50">
	                <label class="text-gray-500 mb-0">Tag provider</label>   
	                <v-select                    
                        label="display_name"
                        :options="allProviderIds"
                        v-model="task_data.taskable" /> 
	            </div>  
	        </div>
	        <div class="d-flex flex-row-reverse flex-fill text-right mt-2">
	            <button class="btn btn-sm btn-primary ml-1" @click="updateTask()">Save</button>
	            <button class="btn btn-sm btn-ghost-secondary" @click="resetEditing()">Cancel</button>
	        </div> 
	    </template>

        <!-- Display -->
        <div v-else class="d-flex flex-fill align-items-center">
            <div class="check-me mr-2" :class="task.status === 2 ? 'ignored' : ''" @click="changeStatus()">
                <i class="incomplete far fa-circle text-medium text-gray-500"></i>
                <i class="hovering far fa-check-circle text-medium text-gray-500"></i>                 
                <i class="completed fas fa-check-circle text-medium"></i>
                <i class="ignored fas fa-times-circle text-medium"></i>
            </div>
            <div class="flex-grow-1">
            	{{ task.title }}
            	<router-link
                    v-if="task.taskable"
                    :to="{ name: task.taskable_type == 'App\\Physician' ? 'physicians.show' : 'groups.show', params: { id: task.taskable_id } }"
                    class="ml-2 btn btn-light btn-sm">
                    <i class="fal fa-user-md text-gray-700"></i> {{ task.taskable.display_name }}
                </router-link>
            </div>
            <span v-if="task.due_date" :class="moment() > moment(task.due_date) ? 'text-red-500' : 'text-gray-500'">{{ moment(task.due_date).format('MMM D') }}</span>
            <span v-else class="text-gray-500">--</span>
            <div v-if="show_edit" class="drop-down ml-2">
                <a href="#" role="button" class="show-on-hover" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="far fa-ellipsis-h text-xl"></i></a>
                <div class="dropdown-menu dropdown-menu-right py-0" aria-labelledby="dropdownMenuLink">
                    <span class="dropdown-item" @click="setEditing()">Edit task</span>
                    <span class="dropdown-item" @click="changeStatus(2)">Dismiss (ignore)</span>
                    <span class="dropdown-item" @click="deleteTask()">Delete task</span>
                </div>
            </div>                        
        </div>

    </li>
</template>

<script>

    import { mapGetters, mapState } from 'vuex';

	export default {
        props: ['task', 'task_types', 'show_edit'],

        data() {
            return {
                task_data: {
                    taskable: {}
                },
            	editing: false,
                options: false,

                taskable: {},
            }
        },

        methods: {
        	setEditing() {
                this.editing = true;
                this.task_data = { ...this.task };
                
                if (this.task.due_date) {
                    this.task_data.due_date = moment(this.task.due_date);
                }

                if (this.task.taskable_id) {
                    this.options = true;
                    this.task_data.taskable = this.allProviderIds.find(provider => provider.morphable_id == this.task.taskable_id && provider.morphable_type == this.task.taskable_type)
                }
        	},

        	resetEditing() {
        		this.editing = false;
        	},

            toggleOptions() {
                this.options = !this.options;
            },

            changeStatus(status) {
            	let new_status = '';

            	if (this.task.status === 0) {
            		new_status = 1;
            	}
            	if (this.task.status === 1) {
            		new_status = 0;
            	}
            	if (status === 2) {
            		new_status = 2;
            	}

                let statusData = {
                    'id': this.task.id,
                    'status': new_status,
                };

                this.$emit('status-changed', statusData);            
            },

            updateTask() {
                this.$emit('task-updated', this.task_data);
                this.resetEditing();
            },

            deleteTask() {
                this.$emit('task-deleted', this.task.id);
            },
        },

        computed: {
            ...mapGetters(['allProviderIds']),
            ...mapState(['config']),
        },
    }
</script>

<style scoped>
    .complete { text-decoration:line-through; }

    .check-me { position:relative; }
    .check-me i { cursor:pointer; }


    /* hide impossibles */
    .incomplete .check-me i.ignored { display:none; }
    .complete .check-me i.incomplete { display:none; }
    .complete .check-me i.hovering { display:none; }

    /* hide ignored by default, re-enabled explicitly */
    .complete .check-me i.ignored { display:none; }
    .complete .check-me.ignored i.ignored { display:block; text-decoration:none !important; }
    .complete .check-me.ignored i.completed { display:none; }

    /* hover effects */
    .incomplete .check-me .completed { opacity:0; transition:.2s all ease-in; position:absolute; top:0; left:0; }
    .incomplete .check-me .hovering { opacity:.4; transition:.2s all ease-in; position:absolute; top:0; left:0; }
    
    .incomplete .check-me:hover .hovering { opacity:1; transition:.2s all ease-in; }

    /* click effects */
    .incomplete .check-me:active .completed { opacity:1; color:green; }
    .incomplete .check-me:active .hovering { opacity:0; }
    .complete .check-me:active .completed { opacity:0; }
    .complete .check-me:active .incomplete { opacity:1; display:block; position:absolute; top:0; left:0; }
</style>